<template>
  <div class="py-6">
    <!-- タイトル -->
    <h2 class="text-h4 font-weight-bold mb-4">
      買い物リスト
      <!-- URLコピー -->
      <v-btn
        @click="copy_to_clipboard(this_vue_url + uuid);"
      >
        <v-icon class="cursor-pointer">mdi-share</v-icon>            
        <v-snackbar 
          v-model="show_copy_toast" timeout="1000"
          style="align-items: center; text-align-last: center;"
          color="light-blue-lighten-4"
        >
          共有URLをコピーしました。
        </v-snackbar>
      </v-btn>
    </h2>
    
    <!-- 買い物リスト -->
    <KaimonoListComp 
      :columns="cart_header" 
      :items="cart_items" 
      :order="cart_order"
      :filter="cart_header"
      @click_check="click_check"
      @update="update_cart_order" 
      @click_row="open_item_detail"
      table_stayle="width: 100%;"
      :column_width_list="column_width_list"
    />

    <!-- フローティング追加ボタン -->
    <v-btn 
      icon 
      color="primary" 
      class="plus_btn_position"
      style="position: fixed; bottom: 20%; right: 24px; z-index: 10;"
      @click="open_item_dialog"
    >
      <v-icon size="36">mdi-plus</v-icon>
    </v-btn>

    <!-- ダイアログ -->
     <DialogBase
      v-model:is_open="is_open_dialog"
      :title="dialog_title"
      @action_yes="update_cart_item"
      :show_del_btn="show_del_btn"
      @action_del="del_item"
    >
      <!-- モダンなフォームレイアウト -->
      <template v-slot:content>
        <v-row dense class="mt-2">
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="form_item.name"
              label="商品名 *"
              :rules="[v => !!v || '商品名は必須です']"
              variant="solo-filled"
              density="comfortable"
              persistent-hint
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="form_item.amount"
              label="数量 *"
              type="number"
              :rules="[
                v => (v !== null && v !== '' && !isNaN(v)) || '数量は数字で入力してください',
                v => v >= 0 || '数量は0以上でなければなりません'
              ]"
              variant="solo-filled"
              density="comfortable"
              persistent-hint
            />  
          </v-col>
          <v-col cols="12" sm="6">
            <v-combobox
              v-model="form_item.category"
              :items="categories"
              label="カテゴリ"
              clearable
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-combobox
              v-model="form_item.store"
              :items="stores"
              label="店舗"
              clearable
            />
          </v-col>
        </v-row>
      </template>
    </DialogBase>

    <!-- エラーのトースト -->
    <v-snackbar 
      v-model="show_error_toast" timeout="1000"
      style="align-items: center; text-align-last: center;"
      color="red-accent-1"
    >
      {{ error_toast_msg }}
    </v-snackbar>
  </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useRouter, useRoute } from 'vue-router';
import "firebase/compat/database";
import KaimonoListComp from '@/components/Lists/KaimonoListComp.vue'
import DialogBase from '@/components/Dialog/DialogBase.vue'

  export default {
    name: 'KaimonoList',
    components:{KaimonoListComp, DialogBase},
    setup() {
      // ################
      // ルータ
      // ################
      const route = useRoute();
      const router = useRouter()
      const this_vue_url = "https://www.nariji.net/#/KaimonoTop?uuid="

      // ################
      // ユーザ
      // ################
      const user_id = ref("user_1")
      const user_pw = ref("user_pw")
      const uuid = ref("")
      const url_uuid = route.query.uuid

      const generate_uuid = () => {
        const length = 128
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
          result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        uuid.value = result
      }

      // 他サイトのデータとの重複回避のためのrand文字列
      const local_storage_key = "uuid_my_kaimono_list__fgyudmtudanrt48ukhgiu"
      const save_uuid_localstorage = () => {
        localStorage.setItem(local_storage_key, uuid.value);
      }
      
      const get_uuid_localstorage = () => {
        if (url_uuid) {
          uuid.value = url_uuid
          save_uuid_localstorage()
          return
        }
        uuid.value = localStorage.getItem(local_storage_key);
        if (uuid.value === null || uuid.value === "") {
          generate_uuid()
          save_uuid_localstorage()
        } 
        // ブックマークで復活できるようにURLパラメータ付きのURLに変更
        router.push({
          path: route.path, // 今いるパスを維持
          query: { uuid: uuid.value }  // クエリパラメータだけ変える
        })
      }
    
      
      // ##########################
      // リストデータ: 買いものリスト
      // ##########################
      const cart_header = ref([
        { key: 'checked', label: 'チェック' },
        // { key: 'name', label: '名前' },
        // { key: 'amount', label: '数' },
        { key: 'category', label: 'ｶﾃｺﾞﾘ' },
        { key: 'store', label: '店' },
      ])
      const column_width_list = [5, 70, 25]
      
      const cart_order = ref([
        "checked", "name", "amount", "category", "store"
      ])

      const cart_items = ref([])

      const update_cart_order = (new_items, is_save) => {
        if(Array.isArray(new_items)) {
          cart_items.value = new_items;
          if(is_save) {
            update_items()
          }
        }
      }

      const open_item_detail = (element) => {
        // form_item.
        form_item.value = { ...element }
        // ダイアログ表示
        dialog_title.value = "買い物リストを更新する"
        show_del_btn.value = true
        is_open_dialog.value = true
      }      
      
      const generate_rand = (length) => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
          result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result
      }
      
      // ##########################
      // カテゴリ, お店 
      // ##########################
      const categories = computed(() => {
        const unique_category_list = [...new Set(cart_items.value.map(item => item.category))];
        return unique_category_list
      })
      const stores = computed(() => {
        const unique_store_list = [...new Set(cart_items.value.map(item => item.store))];
        return unique_store_list
      })

      
      // ##########################
      // DBキー一覧
      // ##########################
      const db_keys = computed(() => {
        const unique_store_list = [...new Set(cart_items.value.map(item => item.key))];
        return unique_store_list
      })
      const generate_db_key = () => {
        let loop_cond = true
        let temp_db_key = ""
        while (loop_cond) {
          temp_db_key = "-OS" + generate_rand(18)
          loop_cond = db_keys.value.includes(temp_db_key)
        }
        return temp_db_key
      }
      
      
      // ##########################
      // ソート番号の最大
      // ##########################
      const max_row_index = computed(() => {
        const maxRowIndex = Math.max(...cart_items.value.map(item => item.row_index));
        return maxRowIndex
      })

      // ################
      // フォーム
      // ################
      const dialog_title = ref("")
      const is_open_dialog = ref(false)
      const show_del_btn = ref(false)

      const form_item = ref({
        key: -1,
        category: "",
        name: "",
        amount: 1,
        store: "",
        checked: false,
        row_index: 999,
      })

      const init_form = ()=> {
        form_item.value.key = generate_db_key()
        form_item.value.category = ""
        form_item.value.name = ""
        form_item.value.amount = 1
        form_item.value.store = ""
        form_item.value.checked = false
        form_item.value.row_index = max_row_index.value + 1
      }

      const open_item_dialog = () => {
        init_form()
        dialog_title.value = "買い物リストを追加する"
        show_del_btn.value = false
        is_open_dialog.value = true
      }

      

      // ########
      // DB接続 #
      // ########
      const request_db = async (body) => {
        const body_json = JSON.stringify(body)
        show_progress_toast.value = true
        try {
          // 通信
          const res = await fetch('https://sdlkv7ydm2.execute-api.ap-northeast-1.amazonaws.com/LambdaApi', {
            method: 'POST',  // APIがPOSTを期待していれば
            headers: {
              'Content-Type': 'application/json'
            },
            body: body_json,
          });

          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }

          const json = await res.json();
          return json;

        } catch (err) {
          alert("[error]\n" + err)
        }
      };

      // ##################
      // DBからのデータ取得
      // ##################
      const get_cart_items = async () => {
        const body = {
          user: {
            user_id: uuid.value,
            user_pw: user_pw.value
          },
          get_item: { key: 1 }
        };
        const carts_item_dict = await request_db(body);
        if (carts_item_dict === null) {
          cart_items.value = []
        } else {
          cart_items.value = Object.entries(carts_item_dict).map(([key, value]) => ({
            key,
            ...value
          }));
        }
      };


      // ################
      // 追加 / 単体更新 #
      // ################
      const update_cart_item = async () => {
        // NG: 必要な入力がない
        if (!form_item.value.name || form_item.value.amount < 0) {
          show_error_toast.value = true
          error_toast_msg.value = "必要な入力がありません。"
          return
        }
        // NG: 同名のデータがある
        if (is_contain_same_name(form_item.value.key, form_item.value.name)) {
          show_error_toast.value = true
          error_toast_msg.value = "同じ名前のデータが存在しています。"
          return
        }
        // 追加or更新 
        if( dialog_title.value === "買い物リストを追加する") {
          await post_item()
        } else {
          await update_item()
        }
        // 更新後のデータを取得
        cart_items.value = update_sort_number(cart_items.value)
        await update_items()
        is_open_dialog.value = false
      }

      // ######################
      // DBへのデータ格納: 保存
      // ######################
      const post_item = async () => {
        cart_items.value.push(form_item.value)
        // **リクエスト不要**
        // // DBにデータ送信
        // const body = {
        //   user: {
        //     user_id: uuid.value,
        //     user_pw: user_pw.value
        //   },
        //   post_item: {
        //     key: generate_db_key(),
        //     category: form_item.value.category,
        //     row_index: max_row_index.value + 1,
        //     name: form_item.value.name,
        //     amount: form_item.value.amount,
        //     store: form_item.value.store,
        //     checked: false
        //   }
        // };
        // await request_db(body);
        // // 通信後の処理
        // await get_cart_items()
      }
      
      // ######################
      // DBへのデータ格納: 更新
      // ######################
      const update_items = async () => {
        // DBにデータ送信
        const body = {
          user: {
            user_id: uuid.value,
            user_pw: user_pw.value
          },
          update_items: cart_items.value
        };
        const old_data = cart_items.value
        await request_db(body);
        // 更新後のデータ取得
        // await get_cart_items()
        // 更新後のデータ整合性チェック
        const isEqual = JSON.stringify(old_data) === JSON.stringify(cart_items.value);
        console.log(old_data)
        console.log(cart_items.value)
        console.log(isEqual); // true
      }

      const update_item = async () => {
        const target_index = cart_items.value.findIndex(item => item.key === form_item.value.key);          
        if (target_index !== -1) {
          cart_items.value[target_index] = form_item.value;
        }
        // **リクエスト不要**
        // // DBにデータ送信
        // const body = {
        //   user: {
        //     user_id: uuid.value,
        //     user_pw: user_pw.value
        //   },
        //   update_item: {
        //     key: form_item.value.key,
        //     category: form_item.value.category,
        //     row_index: form_item.value.row_index,
        //     name: form_item.value.name,
        //     amount: form_item.value.amount,
        //     store: form_item.value.store,
        //     checked: form_item.value.checked
        //   }
        // };
        // await request_db(body);
        // await get_cart_items()
      }

      // ######################
      // DBへのデータ格納: 削除
      // ######################
      const del_item = async () => {
        if (form_item.value.key === ""){
          return
        }
        // 指定したデータを取り除く
        const target_index = cart_items.value.findIndex(item => item.key === form_item.value.key);          
        if (target_index !== -1) {
          cart_items.value.splice(target_index, 1)
        }
        // **リクエスト不要**
        // // DBにデータ送信
        // const body = {
        //   user: {
        //     user_id: uuid.value,
        //     user_pw: user_pw.value
        //   },
        //   del_item: {
        //     key: form_item.value.key,
        //   }
        // };
        // await request_db(body);
        // // 更新されたDBをもとに、ソートして、ソートされたデータをDBに反映して、DBからデータを取り直す...
        // await get_cart_items()
        cart_items.value = update_sort_number(cart_items.value)
        update_items()
        // await get_cart_items()
        is_open_dialog.value = false
      }


      // ###############
      // 購入済チェック #
      // ###############
      const click_check = (element) => {
        // form_item
        form_item.value = { ...element }
        form_item.value.checked = !form_item.value.checked
        update_cart_item()
      }

      // #######
      // Utils #
      // #######
      const is_contain_same_name = (target_key, target_name) => {
        // 異なるKeyで、同じ名前が存在しているか？
        const is_exists = cart_items.value.some(item => item.key !== target_key && item.name === target_name);
        return is_exists
      }

      // ###############
      // ソート番号付与 #
      // ###############
      const update_sort_number = (target_items) => {
          return target_items.map((item, index) => ({
              ...item,
              row_index: index + 1
          }));  
      }


      // ###############
      // クリップボード #
      // ###############
      const copy_to_clipboard = (text) => {
        navigator.clipboard.writeText(text)
        .then(() => {
          console.log("コピー成功:", text);
          // 必要なら通知やトーストを表示
          show_copy_toast.value = true
        })
        .catch(err => {
          console.error("コピー失敗:", err);
        });
      }

      // #########
      // トースト #
      // #########
      const show_progress_toast = ref(false)
      const show_copy_toast = ref(false)
      const show_error_toast = ref(false)
      const error_toast_msg = ref("")

      // ###############
      // ライフサイクル #
      // ###############      
      onMounted (() => {
        get_uuid_localstorage()
        get_cart_items()
      })
      

      return {
        // 画面データ
        cart_header, cart_items, cart_order, update_cart_order, open_item_detail,
        categories,
        stores,
        db_keys,
        column_width_list,
        generate_db_key,
        // クリック
        click_check,
        // フォーム
        form_item,
        init_form,
        max_row_index,
        // ダイアログ
        is_open_dialog,
        update_cart_item,
        open_item_dialog,
        dialog_title,
        show_del_btn,
        // DBデータ操作
        get_cart_items,
        post_item,
        update_items,
        update_item,
        del_item,
        // ユーザ情報
        uuid,
        generate_uuid,
        user_id,
        user_pw,
        url_uuid,
        this_vue_url,
        // トースト
        show_copy_toast,
        show_progress_toast,
        show_error_toast,
        error_toast_msg,
        // Utils
        is_contain_same_name,
        copy_to_clipboard,
      }
    }
  }
</script>
  
<style>
.list-item {
  padding: 10px;
  margin-bottom: 6px;
  background-color: #f0f0f0;
  border-radius: 6px;
  cursor: move;
}
.ghost {
  opacity: 0.5;
}
.plus_btn_position {
  width: 45%;
}
.plus_btn_position {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  border-radius: 50%;
}
</style>